export const ItemTypes = {
  CARD: "card",
};

export interface CardDragObject {
  id: string;
  index: number;
}
